import type { ColorEnum } from '@e-socna/data-layer';

import { colorToMuiColor } from './color-to-mui-color.util';

export const colorToPaletteColor = (color: ColorEnum) => {
  const muiColor = colorToMuiColor(color);

  return muiColor === 'default' ? 'grey.500' : `${muiColor}.main`;
};
